import React from "react";

import DocUploadUserList from "./DocUploadUserList";
import DocUploadUserAdd from "./DocUploadUserAdd";

class DocUploadUser extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            category: props.category,
            addMode: false
        }
        this.toggleMode = this.toggleMode.bind(this);
    }

    toggleMode(){
        this.setState({ addMode : !this.state.addMode });
    }

    componentDidUpdate(prevProps){
        if(prevProps.category !== this.props.category){
            this.setState({category: this.props.category});
        }
    }
    render() {
        const { category, addMode } = this.state;
        return (
            <div className="tab-pane fade show active" id="serv" role="tabpanel" aria-labelledby="serv-tab">
                <div className="box-card">
                    <div className="row">
                        <div className="col-md-12">
                            {addMode ?
                                <DocUploadUserAdd
                                    category={category}
                                    toggleMode={this.toggleMode}
                                />
                                :
                                <DocUploadUserList
                                    category={category}
                                    toggleMode={this.toggleMode}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
  }
  
  export default DocUploadUser;  